import { last } from 'ramda';

export const extractFileName = response => {
  const contentDisposition = response.headers?.['content-disposition'];
  return contentDisposition
    ? last(contentDisposition.match(/filename="(.+)"/))
    : last(response.config.url.replace(/\/$/, '').split('/'));
};
